export const FETCH_QUOTES_INITIATED = 'FETCH_QUOTES_INITIATED';
export const FETCH_QUOTES_SUCCEEDED = 'FETCH_QUOTES_SUCCEEDED';
export const FETCH_QUOTES_FAILED = 'FETCH_QUOTES_FAILED';
